import React, { useCallback } from 'react';
import { useReactFlow } from 'reactflow';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  nodeName,
  setUsedNodes,
  onClick,
  ...props
}) {
  const { setNodes, setEdges } = useReactFlow();

  const deleteNode = useCallback(() => {
    setNodes(nodes => nodes.filter(node => node.id !== id));
    setEdges(edges =>
      edges.filter(edge => edge.source !== id && edge.target !== id),
    );
    // Remove from usedNodes so it can be re-added, except for Start node
    if (setUsedNodes && nodeName && nodeName !== 'Start') {
      setUsedNodes(prev => prev.filter(name => name !== nodeName));
    }
    onClick?.();
  }, [id, setNodes, setEdges, setUsedNodes, nodeName, onClick]);

  return (
    <div
      style={{ top, left, right, bottom }}
      className="context-menu rounded-lg overflow-hidden border border-[#E5E7EB] shadow-xl bg-white min-w-[160px] z-50"
      {...props}
    >
      <div className="px-4 py-3 border-b border-gray-100 text-xs text-[#5B6B80] bg-[#F7F9FC] flex justify-center items-center">
        <div>
          <span>Node: {nodeName}</span>
        </div>
        <div>
          <button
            className="text-[#5B6B80] hover:text-red-500"
            onClick={onClick}
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </div>
      {nodeName !== 'Start' && (
        <button
          onClick={deleteNode}
          className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition"
        >
          <DeleteIcon className="text-base mr-2" /> Delete
        </button>
      )}
    </div>
  );
}
